import React, {useContext} from 'react'
import {RiThumbDownFill, RiThumbDownLine, RiThumbUpFill, RiThumbUpLine,} from 'react-icons/ri'
import {NullAsDefault} from 'views/Shared'
import Count from './Count'
import {VoteTypes} from './Vote'
import {BiLike, BiSolidLike} from "react-icons/bi";
import Translate from "../../modules/local/Translate";
import classNames from "classnames";
import {LayoutContext} from "../layouts/Default/LayoutContext";
import {PiHandsPraying, PiHandsPrayingFill} from "react-icons/pi";
import {ifThenElseMultipleConditions} from "../../helpers/ifThenElseMultipleConditions";

export const Like = React.memo(({type, vote_status, total_votes = 0, handleVote}) => {
    const {isLg} = useContext(LayoutContext)

    return (
        <Translate>
            {t => (
                <div onClick={handleVote}
                     style={{padding: isLg ? '4px 10px' : '4px'}}
                     className="flex items-center gap-1 md:gap-2 hover:background-200 rounded-md cursor-pointer">
                    {type === 'prayer' ? (
                        !!vote_status ? <PiHandsPrayingFill size={17} className="text-primary"/> :
                            <PiHandsPraying size={17} className="text-color-200"/>
                    ) : (
                        !!vote_status ? <BiSolidLike size={17} className="text-primary"/> :
                            <BiLike size={17} className="text-color-200"/>
                    )}
                    <span
                        className={classNames("text-xs md:text-sm", !!vote_status ? 'font-medium text-primary' : 'text-color-300')}>
                        {ifThenElseMultipleConditions(
                            t(!!vote_status ? 'liked' : 'like'),
                            type === 'prayer', t('communion')
                        )}
                    </span>
                </div>
            )}
        </Translate>
    )
})

export const ExtraLike = React.memo(
    ({
         vote_status,
         total_votes = 0,
         total_downvotes = 0,
         handleExtraVote = NullAsDefault,
         onClick,
         action,
     }) => {
        const isVotedUp = vote_status === VoteTypes.UP

        const isVotedDown = vote_status === VoteTypes.DOWN

        switch (action) {
            case VoteTypes.UP:
                return (
                    <Count
                        active={!!isVotedUp}
                        defaultNumber={total_votes}
                        color="text-primary"
                        onClick={onClick ? onClick : () => handleExtraVote(VoteTypes.UP)}
                        {...(!!isVotedUp
                            ? {
                                component: RiThumbUpFill, size: 17
                            }
                            : {
                                component: RiThumbUpLine, size: 17
                            })}
                    />
                )
            case VoteTypes.DOWN:
                return (
                    <Count
                        active={!!isVotedDown}
                        defaultNumber={total_downvotes}
                        color="text-primary"
                        onClick={onClick ? onClick : () => handleExtraVote(VoteTypes.DOWN)}
                        {...(!!isVotedDown
                            ? {
                                component: RiThumbDownFill, size: 17
                            }
                            : {
                                component: RiThumbDownLine, size: 17
                            })}
                    />
                )
        }
    }
)
